'use client';

import { Fireworks } from '../Fireworks';
import { Snowfall } from '../Snowfall';

export type SeasonalEffectType = 'none' | 'snow' | 'fireworks';

interface SeasonalEffectProps {
  effect: SeasonalEffectType;
}

export const SeasonalEffect = ({ effect }: SeasonalEffectProps) => {
  switch (effect) {
    case 'snow':
      return <Snowfall />;
    case 'fireworks':
      return <Fireworks />;
    default:
      return null;
  }
};
